import { ResearchUnit } from './research-unit';

export class CompanyWithResearchUnits {
  constructor(
    public hash?: string,
    public commercialName?: string,
    public businessName?: string,
    public taxNumber?: string,
    public researchUnits?: ResearchUnit[]
  ) { }

  clone() {
    return new CompanyWithResearchUnits(
      this.hash,
      this.commercialName,
      this.businessName,
      this.taxNumber,
      this.researchUnits
    );
  }
}
